import {createFeatureSelector, createSelector} from '@ngrx/store';
import {userFeatureKey, UserState} from "../reducers/user.reducer";
import {FavoriteEntityType} from "../../enums/favorite-entity-type";
import {FavoriteId} from "../../ts-types/favorite-id";

export const selectJobFiltersFeature = createFeatureSelector<UserState>(
  userFeatureKey
);

export const getAllFavorites = () => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {
    return state.favorites;
  }
);

export const getFavoritesByTypes = (...entityType: FavoriteEntityType[]) => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {
    return state.favorites.filter((el) => entityType.indexOf(el.type) !== -1);
  }
);

export const isEntityInFavorites = (id: FavoriteId) => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {
    return state.favorites.findIndex(el => el.id === id) !== -1;
  }
);

export const getFavoritesCode = () => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {
    return state.favoritesCode
  }
);


export const getSelfAssessedRequirements = () => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {
    return state.selfAssessedRequirements;
  }
);

export const getUserStateByKey = (key: string) => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {

    if (key !== '' && state.hasOwnProperty(key)) {
      // @ts-ignore
      return state[key]
    }

    return false;
  }
);

export const getUserSelfAssessedRequirementsTimeout = () => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {

    return state.selfAssessedRequirementsTimeout;
  }
);

export const getCookieAcceptDate = () => createSelector(
  selectJobFiltersFeature,
  (state: UserState) => {
    return state.cookieAcceptDate;
  }
);

